import * as React from "react";
import type { UseFormRegisterReturn } from "react-hook-form";

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  PasswordInput,
} from "@/components/ui";

interface PasswordFormFieldProps {
  label?: string;
  type?: HTMLInputElement["type"];
  className?: string;
  register: UseFormRegisterReturn;
  disabled?: boolean;
  dataTestId?: string;
}

export const PasswordFormField = React.forwardRef<
  HTMLInputElement,
  PasswordFormFieldProps & {
    label?: string;
    className?: string;
    register: UseFormRegisterReturn;
  }
>(({ label, className, register, dataTestId }, ref) => {
  return (
    <FormField
      {...register}
      // @ts-expect-error This line is to remove a console error
      ref={null}
      render={({ field }) => (
        <FormItem className={className}>
          <div className="flex">
            {label && <FormLabel>{label}</FormLabel>}
            <FormMessage
              data-testid="error-message"
              className="grow text-right"
            />
          </div>
          <FormControl>
            <PasswordInput
              data-testid={dataTestId}
              {...field}
              ref={ref}
            ></PasswordInput>
          </FormControl>
        </FormItem>
      )}
    />
  );
});
PasswordFormField.displayName = "PasswordFormField";
